import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";

import { Trans, useTranslation } from "react-i18next";

import Particle from "../Particle";

// Slider
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import SlickLazyImage from "../shared/SlickLazyImage";

// Afterschool images
import afterschool1 from "../../Assets/afterschool1.jpg";
import afterschool2 from "../../Assets/afterschool2.jpg";
import afterschool3 from "../../Assets/afterschool3.jpg";
import afterschool4 from "../../Assets/afterschool4.jpg";
import afterschool5 from "../../Assets/afterschool.jpeg";

// Camps images
import campA from "../../Assets/cf_1.png";
import campB from "../../Assets/cf_2.png";
import campC from "../../Assets/camp1.png";

// Workshops images
import workshopA from "../../Assets/cf_e2.png";
import workshopB from "../../Assets/cf_1.png";
import workshopC from "../../Assets/cf_e3.png";
import workshopD from "../../Assets/cf_e1.png";
import workshopE from "../../Assets/workshop1.jpg";

const WORKSHOPS_FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSfw79a85sHFn3zXedEE8bfWOwSPc82VZ28drPHTPhJm2eJG9w/viewform";
const AFTERSCHOOL_FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSfyUZt4peUyGezMs72Taa9NH0s-IayV7VJpHF8kV7YQbZ1tpg/viewform";
const TECH_CAMPS_FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSfyUZt4peUyGezMs72Taa9NH0s-IayV7VJpHF8kV7YQbZ1tpg/viewform";

function ProgramMediaSlider({ images, alt, dots = true }) {
  const [activeSlide, setActiveSlide] = React.useState(0);

  const settings = {
    dots,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3600,
    pauseOnHover: true,
    pauseOnFocus: true,
    lazyLoad: "progressive",
    beforeChange: (_current, next) => setActiveSlide(next),
  };

  return (
    <Slider {...settings}>
      {images.map((src, index) => (
        <div key={src}>
          <SlickLazyImage
            src={src}
            alt={alt}
            className="hands-on-learning-slide-img"
            index={index}
            activeIndex={activeSlide}
            total={images.length}
            buffer={2}
            eager={index === 0}
          />
        </div>
      ))}
    </Slider>
  );
}

function HandsOnLearning() {
  const { t } = useTranslation();

  const afterschoolWhyRaw = t("handsOnLearningPage.afterschool.moreDetails.why.items", { returnObjects: true });
  const afterschoolWhyItems = Array.isArray(afterschoolWhyRaw) ? afterschoolWhyRaw : [];

  const afterschoolApproachRaw = t("handsOnLearningPage.afterschool.moreDetails.approach.items", { returnObjects: true });
  const afterschoolApproachItems = Array.isArray(afterschoolApproachRaw) ? afterschoolApproachRaw : [];

  const campsLearn = t("handsOnLearningPage.camps.learnExplore.items", { returnObjects: true });
  const campsLearnItems = Array.isArray(campsLearn) ? campsLearn : [];

  const campsGainRaw = t("handsOnLearningPage.camps.whatYouGain.items", { returnObjects: true });
  const campsGainItems = Array.isArray(campsGainRaw) ? campsGainRaw : [];

  const workshopsLearn = t("handsOnLearningPage.workshops.learnExplore.items", { returnObjects: true });
  const workshopsLearnItems = Array.isArray(workshopsLearn) ? workshopsLearn : [];

  const workshopsGainRaw = t("handsOnLearningPage.workshops.whatYouGain.items", { returnObjects: true });
  const workshopsGainItems = Array.isArray(workshopsGainRaw) ? workshopsGainRaw : [];

  const afterschoolExplore = t("handsOnLearningPage.afterschool.explore.items", { returnObjects: true });
  const afterschoolExploreItems = Array.isArray(afterschoolExplore) ? afterschoolExplore : [];

  const afterschoolImages = [afterschool1, afterschool2, afterschool3, afterschool4, afterschool5];
  const campsImages = [campA, campB, campC];
  const workshopsImages = [workshopA, workshopB, workshopC, workshopD, workshopE];

  React.useEffect(() => {
    document.title = "Community Tech Programs";
  }, []);

  return (
    <Container fluid className="about-section hands-on-learning-page">
      <Particle />

      <Container className="hands-on-learning-container">
        <header className="hands-on-learning-hero">
          <div className="hands-on-learning-eyebrow">{t("handsOnLearningPage.eyebrow")}</div>

          <h1 className="hands-on-learning-hero-title">
            <Trans i18nKey="handsOnLearningPage.hero.title" components={{ purple: <span className="purple" /> }} />
          </h1>

          <p className="hands-on-learning-hero-lead">{t("handsOnLearningPage.hero.lead")}</p>

          <div className="hands-on-learning-hero-actions" aria-label={t("handsOnLearningPage.a11y.heroActions")}>
            <a className="hands-on-learning-anchor" href="#hands-on-afterschool">
              {t("handsOnLearningPage.hero.jump.afterschool")}
            </a>
            <a className="hands-on-learning-anchor" href="#hands-on-camps">
              {t("handsOnLearningPage.hero.jump.camps")}
            </a>
            <a className="hands-on-learning-anchor" href="#hands-on-workshops">
              {t("handsOnLearningPage.hero.jump.workshops")}
            </a>
          </div>

          <div className="hands-on-learning-hero-note">
            <span className="hands-on-learning-email">{t("handsOnLearningPage.common.contact")}</span>
            <a className="hands-on-learning-email-link" href="mailto:info@choicestfruit.com">
              info@choicestfruit.com
            </a>
          </div>
        </header>

        {/* Afterschool */}
        <section
          id="hands-on-afterschool"
          className="hands-on-learning-section"
          aria-label={t("handsOnLearningPage.a11y.afterschool")}
        >
          <Row className="hands-on-learning-split" xs={1} lg={2}>
            <Col className="about-top-col">
              <div className="policy-card hands-on-learning-panel hands-on-learning-panel--compact">
                <div className="hands-on-learning-kicker">{t("handsOnLearningPage.afterschool.kicker")}</div>

                <h2 className="hands-on-learning-section-title">
                  <Trans i18nKey="handsOnLearningPage.afterschool.title" components={{ purple: <span className="purple" /> }} />
                </h2>

                <p className="hands-on-learning-section-lead">{t("handsOnLearningPage.afterschool.lead")}</p>

                <p className="hands-on-learning-paragraph">{t("handsOnLearningPage.afterschool.blurb")}</p>

                <p className="hands-on-learning-paragraph">{t("handsOnLearningPage.afterschool.blurbFollowUp")}</p>

                <p className="hands-on-learning-paragraph">
                  <strong>{t("handsOnLearningPage.afterschool.exploreTitle")}</strong> {afterschoolExploreItems.join(", ")}.{" "}
                  <strong>{t("handsOnLearningPage.afterschool.agesLabel")}</strong> {t("handsOnLearningPage.afterschool.ages")}.<br />
                  <strong>{t("handsOnLearningPage.afterschool.servingLabel")}</strong> {t("handsOnLearningPage.afterschool.serving")}
                </p>

                <div className="hands-on-learning-cta">
                  <Button
                    as="a"
                    href={AFTERSCHOOL_FORM_URL}
                    target="_blank"
                    rel="noreferrer"
                    className="custom-yellow-btn hands-on-learning-btn"
                  >
                    {t("handsOnLearningPage.common.register")}
                  </Button>
                </div>
              </div>
            </Col>

            <Col className="about-top-col">
              <div className="policy-card hands-on-learning-media-card">
                <ProgramMediaSlider images={afterschoolImages} alt={t("programs.afterschool.sliderAlt")} dots={false} />
              </div>
            </Col>
          </Row>

          <div className="hands-on-learning-subcards" aria-label={t("handsOnLearningPage.common.moreDetails")}
          >
            <div className="hands-on-learning-details-grid">
              <div className="policy-card hands-on-learning-details-card" aria-label={t("handsOnLearningPage.afterschool.moreDetails.why.title")}>
                <h3 className="hands-on-learning-subtitle">{t("handsOnLearningPage.afterschool.moreDetails.why.title")}</h3>

                <div className="hands-on-learning-subcard-body">
                  <p className="hands-on-learning-paragraph">{t("handsOnLearningPage.afterschool.moreDetails.why.tagline")}</p>
                  <p className="hands-on-learning-paragraph">{t("handsOnLearningPage.afterschool.moreDetails.intro")}</p>
                  <p className="hands-on-learning-paragraph">
                    <strong>{t("handsOnLearningPage.afterschool.moreDetails.why.focusTitle")}</strong>
                  </p>
                  <ul className="hands-on-learning-list">
                    {afterschoolWhyItems.map((item) => (
                      <li key={item.label}>
                        <strong className="purple">{item.label}:</strong> {item.text}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              <div
                className="policy-card hands-on-learning-details-card hands-on-learning-details-card--accent"
                aria-label={t("handsOnLearningPage.afterschool.moreDetails.approach.title")}
              >
                <h3 className="hands-on-learning-subtitle">{t("handsOnLearningPage.afterschool.moreDetails.approach.title")}</h3>

                <div className="hands-on-learning-subcard-body">
                  <p className="hands-on-learning-paragraph">{t("handsOnLearningPage.afterschool.moreDetails.approach.tagline")}</p>
                  <p className="hands-on-learning-paragraph">{t("handsOnLearningPage.afterschool.moreDetails.approach.intro")}</p>
                  <p className="hands-on-learning-paragraph">
                    <strong>{t("handsOnLearningPage.afterschool.moreDetails.approach.focusTitle")}</strong>
                  </p>
                  <ul className="hands-on-learning-list">
                    {afterschoolApproachItems.map((item) => (
                      <li key={item.label}>
                        <strong className="purple">{item.label}:</strong> {item.text}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Camps */}
        <section
          id="hands-on-camps"
          className="hands-on-learning-section"
          aria-label={t("handsOnLearningPage.a11y.camps")}
        >
          <Row className="hands-on-learning-split" xs={1} lg={2}>
            <Col className="about-top-col">
              <div className="policy-card hands-on-learning-panel hands-on-learning-panel--compact">
                <div className="hands-on-learning-kicker">{t("handsOnLearningPage.camps.kicker")}</div>

                <h2 className="hands-on-learning-section-title">
                  <Trans i18nKey="handsOnLearningPage.camps.title" components={{ purple: <span className="purple" /> }} />
                </h2>

                <p className="hands-on-learning-section-lead">{t("handsOnLearningPage.camps.lead")}</p>
                <h3 className="hands-on-learning-subtitle">{t("handsOnLearningPage.common.whatItIs")}</h3>
                <p className="hands-on-learning-paragraph">{t("handsOnLearningPage.camps.whatItIs")}</p>
                <p className="hands-on-learning-paragraph">{t("handsOnLearningPage.camps.whatItIsFollowUp")}</p>

                <div className="hands-on-learning-cta">
                  <Button
                    as="a"
                    href={TECH_CAMPS_FORM_URL}
                    target="_blank"
                    rel="noreferrer"
                    className="custom-yellow-btn hands-on-learning-btn"
                  >
                    {t("handsOnLearningPage.common.register")}
                  </Button>
                </div>
              </div>
            </Col>

            <Col className="about-top-col">
              <div className="policy-card hands-on-learning-media-card">
                <ProgramMediaSlider images={campsImages} alt={t("programs.camps.imageAlt")} dots={false} />
              </div>
            </Col>
          </Row>

          <div className="hands-on-learning-subcards" aria-label={t("handsOnLearningPage.common.moreDetails")}>
            <div className="hands-on-learning-details-grid">
              <div className="policy-card hands-on-learning-details-card" aria-label={t("handsOnLearningPage.camps.learnExplore.title")}>
                <h3 className="hands-on-learning-subtitle">{t("handsOnLearningPage.camps.learnExplore.title")}</h3>

                <div className="hands-on-learning-subcard-body">
                  <p className="hands-on-learning-paragraph">{t("handsOnLearningPage.camps.learnExplore.tagline")}</p>
                  <ul className="hands-on-learning-list">
                    {campsLearnItems.map((item) => {
                      const [label, ...rest] = String(item).split(":");
                      const text = rest.join(":").trim();
                      const cleanLabel = label.trim();

                      return (
                        <li key={String(item)}>
                          {text ? (
                            <>
                              <strong className="purple">{cleanLabel}:</strong> {text}
                            </>
                          ) : (
                            item
                          )}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>

              <div
                className="policy-card hands-on-learning-details-card hands-on-learning-details-card--accent"
                aria-label={t("handsOnLearningPage.camps.whatYouGain.title")}
              >
                <h3 className="hands-on-learning-subtitle">{t("handsOnLearningPage.camps.whatYouGain.title")}</h3>

                <div className="hands-on-learning-subcard-body">
                  <p className="hands-on-learning-paragraph">{t("handsOnLearningPage.camps.whatYouGain.tagline")}</p>
                  <ul className="hands-on-learning-list">
                    {campsGainItems.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>

                  <div className="hands-on-learning-meta">
                    <span className="hands-on-learning-meta-item">
                      <strong>{t("handsOnLearningPage.common.openTo")}</strong> {t("handsOnLearningPage.camps.openTo")}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Workshops */}
        <section
          id="hands-on-workshops"
          className="hands-on-learning-section"
          aria-label={t("handsOnLearningPage.a11y.workshops")}
        >
          <Row className="hands-on-learning-split" xs={1} lg={2}>
            <Col className="about-top-col">
              <div className="policy-card hands-on-learning-panel hands-on-learning-panel--accent hands-on-learning-panel--compact">
                <div className="hands-on-learning-kicker">{t("handsOnLearningPage.workshops.kicker")}</div>

                <h2 className="hands-on-learning-section-title">
                  <Trans i18nKey="handsOnLearningPage.workshops.title" components={{ purple: <span className="purple" /> }} />
                </h2>

                <p className="hands-on-learning-section-lead">{t("handsOnLearningPage.workshops.lead")}</p>
                <h3 className="hands-on-learning-subtitle">{t("handsOnLearningPage.common.whatItIs")}</h3>
                <p className="hands-on-learning-paragraph">{t("handsOnLearningPage.workshops.whatItIs")}</p>
                <p className="hands-on-learning-paragraph">{t("handsOnLearningPage.workshops.whatItIsFollowUp")}</p>

                <div className="hands-on-learning-cta">
                  <Button
                    as="a"
                    href={WORKSHOPS_FORM_URL}
                    target="_blank"
                    rel="noreferrer"
                    className="custom-yellow-btn hands-on-learning-btn"
                  >
                    {t("handsOnLearningPage.common.register")}
                  </Button>
                </div>
              </div>
            </Col>

            <Col className="about-top-col">
              <div className="policy-card hands-on-learning-media-card">
                <ProgramMediaSlider images={workshopsImages} alt={t("programs.workshops.sliderAlt")} dots={false} />
              </div>
            </Col>
          </Row>

          <div className="hands-on-learning-subcards" aria-label={t("handsOnLearningPage.common.moreDetails")}>
            <div className="hands-on-learning-details-grid">
              <div className="policy-card hands-on-learning-details-card" aria-label={t("handsOnLearningPage.workshops.learnExplore.title")}>
                <h3 className="hands-on-learning-subtitle">{t("handsOnLearningPage.workshops.learnExplore.title")}</h3>

                <div className="hands-on-learning-subcard-body">
                  <p className="hands-on-learning-paragraph">{t("handsOnLearningPage.workshops.learnExplore.tagline")}</p>
                  <ul className="hands-on-learning-list">
                    {workshopsLearnItems.map((item) => {
                      const [label, ...rest] = String(item).split(":");
                      const text = rest.join(":").trim();
                      const cleanLabel = label.trim();

                      return (
                        <li key={String(item)}>
                          {text ? (
                            <>
                              <strong className="purple">{cleanLabel}:</strong> {text}
                            </>
                          ) : (
                            item
                          )}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>

              <div
                className="policy-card hands-on-learning-details-card hands-on-learning-details-card--accent"
                aria-label={t("handsOnLearningPage.workshops.whatYouGain.title")}
              >
                <h3 className="hands-on-learning-subtitle">{t("handsOnLearningPage.workshops.whatYouGain.title")}</h3>

                <div className="hands-on-learning-subcard-body">
                  <p className="hands-on-learning-paragraph">{t("handsOnLearningPage.workshops.whatYouGain.tagline")}</p>
                  <ul className="hands-on-learning-list">
                    {workshopsGainItems.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>

                  <p className="hands-on-learning-paragraph">{t("handsOnLearningPage.workshops.whatYouGain.followUp")}</p>

                  <div className="hands-on-learning-meta">
                    <span className="hands-on-learning-meta-item">
                      <strong>{t("handsOnLearningPage.common.openTo")}</strong> {t("handsOnLearningPage.workshops.openTo")}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <footer className="hands-on-learning-footer">
          <div className="policy-card hands-on-learning-footer-card">
            <h2 className="hands-on-learning-footer-title">{t("handsOnLearningPage.footer.title")}</h2>
            <p className="hands-on-learning-footer-text">{t("handsOnLearningPage.footer.lead")}</p>
            <p className="hands-on-learning-footer-text">{t("handsOnLearningPage.footer.emailLine")}</p>
          </div>
        </footer>
      </Container>
    </Container>
  );
}

export default HandsOnLearning;


